import React, { useEffect, useState } from "react";

import useAdminParams from "hooks/useAdminParams";
import useIsMounted from "ismounted";

import PortalNavigation from "navigation/PortalNavigation";
import getPortalDetails from "api/getPortalDetails";

import Loader from "components/Loader/Loader";
import Alert from "react-bootstrap/cjs/Alert";

const Portal = ({ children }) => {
  const _mounted = useIsMounted();
  const { portalId } = useAdminParams();

  const [loading, setLoading] = useState(true);
  const [portalData, setPortalData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (_mounted.current) {
      getPortalDetails({ portalId })
        .then(({ data }) => {
          if (_mounted.current) {
            setPortalData(data);
            setLoading(false);
          }
        })
        .catch((error) => {
          if (_mounted.current) {
            setError(error);
            setLoading(false);
          }
        });
    }
  }, [_mounted, portalId]);

  if (loading) return <Loader />;

  if (error) return <Alert variant={"danger"}>This portal could not be retrieved.</Alert>;

  const { company, product } = portalData;

  return (
    <>
      <p className={"mb-1"}>
        {loading && "..."}
        {!loading && (
          <>
            Manage <strong>{product}</strong> for <strong>{company}</strong>
          </>
        )}
      </p>
      <PortalNavigation
        loading={loading}
        courses={portalData ? portalData.courses : []}
        licensed={portalData ? !!portalData.licensed : false}
      />
      {children}
    </>
  );
};

export default Portal;
